import { http } from '../../config/axios'

export default function getOperadoresRegraCredito(): Promise<any[]> {
  return http
    .get('api/motorcredito/operadores')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getOperadoresRegraCredito', error)
      throw Error(error.response.data)
    })
}
